import { ItemTypeCategories } from '@/utils/ItemTypes';
import type { ItemType, ItemTypeCategory } from '@/graphql/generatedTypes';

export const itemTypeCategories = [...ItemTypeCategories, 'ALL'] as const;
export type ItemTypeCategoriesWithAll = (typeof itemTypeCategories)[number];

export type ItemTypeDetailModalMode = 'update' | 'create';

/** The detail form starts without a category; the API requires one on create. */
export type ItemTypeFormState = Omit<ItemType, 'category'> & {
  category: ItemTypeCategory | '';
};
